import React from 'react';

import { Link as RouterLink } from '~/lib/react-router-dom';

import { Link, Stack } from '@mui/material';

import type { CompetitorProperty } from '~/types/services/priceParrot';

import CompetitorOfferMatchChip from './CompetitorOfferMatchChip';
import { lppPropertyPath } from './utils';

interface Props {
  property: CompetitorProperty;
}

export default function CompetitorOfferLppHotelCell({ property }: Props) {
  if (!property.lppPropertyId) {
    return null;
  }
  return (
    <Stack spacing={0.5} alignItems="flex-start">
      <Link
        component={RouterLink}
        to={lppPropertyPath(property.lppPropertyId)}
        target="_blank"
        rel="noopener noreferrer"
        variant="body2"
      >
        {property.lppPropertyName ?? property.lppPropertyId}
      </Link>
      <CompetitorOfferMatchChip matchTier={property.lppMatchTier} />
    </Stack>
  );
}
